<div class="projects py-5" id="projects">
  <div class="container d-flex flex-column align-items-center gap-4">
    <div class="row w-100 gap-4">
      <div class="col-12 d-flex flex-column align-items-center gap-2">
        <h2 class="text-white fw-bold">My Projects</h2>
        <div class="underline"></div>
      </div>
      <div class="col-12">
        <p class="text-center projects-subtitle">
          From real-time apps to Web3 experiences, here are some of the things I’ve built recently.
        </p>
        @if(isBrowser){
        <owl-carousel-o [options]="customOptions">
          @for (project of projects; track project.img) { 
            <ng-template carouselSlide class="text-white">
              <a [href]="project.video" target="_blank">
                <img [src]="project.img" alt="project-img" srcset="" />
              </a>
            </ng-template>
          }
        </owl-carousel-o>
        }

      </div>
    </div>
  </div>
</div>